import { HeatMapAnalyticsActivitySchemaName } from '../heat-maps-analytics-activity.enum';

export enum AnalyticsActivitySegments {
  sunday = 'AnalyticsActivity.sunday',
  monday = 'AnalyticsActivity.monday',
  tuesday = 'AnalyticsActivity.tuesday',
  wednesday = 'AnalyticsActivity.wednesday',
  thursday = 'AnalyticsActivity.thursday',
  friday = 'AnalyticsActivity.friday',
  saturday = 'AnalyticsActivity.saturday',
}

export enum AnalyticsActivityV2Segments {
  sunday = 'AnalyticsActivityV2.sunday',
  monday = 'AnalyticsActivityV2.monday',
  tuesday = 'AnalyticsActivityV2.tuesday',
  wednesday = 'AnalyticsActivityV2.wednesday',
  thursday = 'AnalyticsActivityV2.thursday',
  friday = 'AnalyticsActivityV2.friday',
  saturday = 'AnalyticsActivityV2.saturday',
}